import React from 'react';
import { Text, RichText, withSitecoreContext, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { FullWidthCardCallout as FullWidthCardCalloutNPM } from '@rotaryintl/component-landing-pages';

const FullWidthCardCallout = ({
  rendering,
  params: { ComponentId } = {},
  fields: { BackgroundImageDesktop, BackgroundImageMobile, Title, Description } = {},
}) => {
  if (Title === undefined) {
    return <></>;
  }

  return (
    <FullWidthCardCalloutNPM
      id={ComponentId}
      backgroundImageAlt={BackgroundImageDesktop?.value?.alt}
      backgroundImageDesktop={BackgroundImageDesktop?.value?.src}
      backgroundImageMobile={BackgroundImageMobile?.value?.src}
      title={<Text field={Title} />}
      description={<RichText field={Description} />}
      cardsPlaceholder={<Placeholder name="fullwidthcardcallout-card" rendering={rendering} />}
    />
  );
};

export default withSitecoreContext()(FullWidthCardCallout);
